module.exports = __webpack_public_path__ + "media/images/flags/1x1/grd-02d1ad78c84f5517438c7ecef546ab06.svg";